// src/utils/services/AdvancedMD/allergies.js
import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const ALLERGIES_BY_PATIENT_URL = `${API_BASE_URL}/api/advancedmd/allergies`;

/**
 * Obtiene las alergias de un paciente desde el backend (AdvancedMD).
 * El backend ya se encarga de llamar a AdvancedMD y mapear la respuesta.
 *
 * @param {string|number} patientId
 * @returns {Promise<any>} Lista de alergias (según el DTO que definimos en el backend)
 */
export async function getPatientAllergies(patientId) {
  try {
    const url = `${ALLERGIES_BY_PATIENT_URL}/${encodeURIComponent(patientId)}`;
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.error("Error getPatientAllergies:", err);
    throw err;
  }
}
